import { takeEvery, put, call, all, fork } from "redux-saga/effects"
import { addNewArea, getAreas, updateArea, deleteArea as deleteAreaBackend } from "../../helpers/backend_helper"
import { ADD_NEW_AREA, addAreaSuccess, DELETE_AREA, deleteArea, deleteAreaSuccess, GET_AREAS_LIST, getAreasSuccess, modalAreaShow, AREA_UPDATE, updateAreaSuccess } from "./actions"
import toastr from "toastr";


/**
 * Get all active areas 
 */
function* fetchAreas({ payload: filter }) {
    try {
      const response = yield call(getAreas, filter)
      if(response.success) {
      yield put(getAreasSuccess(response))
      } else {
        toastr.error(response.message)
      }
    } catch (error) {
      yield put(getAreasFail(error))
    }
}

function* onAddNewArea({ payload: area }) {
    try {
      const response = yield call(addNewArea, area)
      if(response.success) {
        toastr.success(response.message)
        yield put(addAreaSuccess(response))
        yield put(modalAreaShow(false))
      } else {
        toastr.error(response.message)
      }
    } catch (error) {
      //yield put(actionFail(error))
        console.log(error)
      toastr.error("Se ha producido un error, intenta nuevamente o contacta con el administrador")
    }
}


function* onUpdateArea({ payload: area }) {
    try {
      const response = yield call(updateArea, area)
      if(response.success) {
        toastr.success(response.message)
        yield put(getAreasSuccess(response))
        yield put(modalAreaShow(false))
      } else {
        toastr.error(response.message)
      }
    } catch (error) {
      //yield put(actionFail(error))
      console.log(error)
      toastr.error("Se ha producido un error, intenta nuevamente o contacta con el administrador")
    }
}
  
function* onDeleteArea({ payload: area }) {
    try {
      const response = yield call(deleteAreaBackend, area)
      if(response.success) {
        toastr.success(response.message)
        yield put(getAreasSuccess(response))
         yield put(modalAreaShow(false))
      } else {
        toastr.error(response.message)
      }
    } catch (error) {
      //yield put(deleteEventFail(error))
      console.log(error)
      toastr.error("Se ha producido un error, intenta nuevamente o contacta con el administrador")
    }
}

  export function* watchAreaSaga() {
    yield takeEvery(GET_AREAS_LIST, fetchAreas)
    yield takeEvery(ADD_NEW_AREA, onAddNewArea)
    yield takeEvery(AREA_UPDATE, onUpdateArea)
    yield takeEvery(DELETE_AREA, onDeleteArea)
}

function* areaSaga() {
    yield all([fork(watchAreaSaga)]);
}

export default areaSaga;
